'use memo';

import { Outlet, createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';
import { useDesktopOrMobileMediaQuery } from '@/hooks/useMediaQuery';
import { IndividualSidebar } from '../../-components/IndividualSidebar';

/**
 * 「書類・公文書」配下の共通レイアウト。
 *
 * portal サイドバー + コンテンツ領域を提供する（lookup 配下と同じ構成）。
 * lookup（台帳の照会）とは別ディレクトリに切っている。並ぶのは台帳ではなく
 * 「本人に交付された書類」で、ID4/ID8 の社内書式の証明書もここへ足していくため。
 */
export const Route = createFileRoute('/_individual/individual/portal/documents')({
  component: DocumentsLayout
});
function DocumentsLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const {
    isDesktop
  } = useDesktopOrMobileMediaQuery();
  return <div className="flex h-full min-h-0 w-full overflow-hidden">
      {isDesktop && <IndividualSidebar mode="portal" open={sidebarOpen} onToggle={() => setSidebarOpen(v => !v)} />}
      <main className="flex min-w-0 flex-1 flex-col overflow-hidden bg-neutral-bottom-fill">
        <Outlet />
      </main>
    </div>;
}